module.exports = __webpack_public_path__ + "img/lock_words.f5fc1742.svg";